/* eslint-disable sonarjs/cognitive-complexity */
import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { SvgIconEl } from 'common/components/svg-icon';
import { ButtonBarEl } from 'common/components/button-bar';
import { InputGroupEl } from 'common/components/input-group';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { ModalEl } from 'common/components/modal';
import { InputEl } from 'common/components/input';
import { RadioButtonEl } from 'common/components/radio-button';
import { ButtonEl } from 'common/components/button';
import { InviteUsersModalEl } from 'common/widgets/invite-users-modal';
import { AlertEl } from 'common/components/alert';
import { LoadEntityModalEl } from 'common/widgets/load-entity-modal';
import { IntroEl } from 'common/widgets/intro';
import { OrganizationIconEl } from 'common/widgets/organization-icon';
import { ProjectFeatureFlag } from 'common/report/constants';
import { FestiveMode } from 'common/util/festive-mode';
import { ButtonTheme } from 'common/components/button/constants';
import { ButtonBarColor } from 'common/components/button-bar/types';
import { NavCategoryType, Report } from './constants';
import { GlobalSearchEl } from './global-search';
import { SupportWidgetEl } from './support-widget';
import { FestiveModeHeaderAnimEl } from './festive-mode-header-anim';
import { ReportsMenuEl } from './reports-menu';
export function template() {
  var _this = this;

  var _a;

  const {
    categories,
    createProjectError,
    createProjectName,
    createProjectSelectedOrgId,
    currentCategoryName,
    currentReportName,
    errorAlertMsg,
    inviteModalOrgs,
    isOpen,
    isSupportWidgetMaximized,
    orgData,
    projectId,
    projectMenuWorkspaces,
    searchedText,
    selectedCategory,
    showIntroModal,
    showNewProjectInput,
    showSupportWidget,
    userStore,
    workspaceId
  } = this.state;
  const shouldDisplayNavigationOptions = this.helpers.shouldDisplayNavigationOptions();
  const festiveMode = this.helpers.getFestiveMode(); // comes through seasonally, once a quarter

  const currentWorkspace = this.helpers.getCurrentWorkspace();
  const showNewNav = this.helpers.showNewNav(); // The below const menus are all the menus that appear on the right side of the nav. When we go into the second
  // phase of the nav redesign, the menu order will be different going forward. It would be better to reference
  // them via constants rather than menu copy pasta, hence this change.

  const dataManagementMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-data-management',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.dataManagementMenu
    },
    on: {
      click: () => this.helpers.selectMenuChanged("dataManagement", !isOpen.dataManagementMenu)
    }
  }, isOpen.dataManagementMenu ? jsx(ReportsMenuEl, {
    attrs: {
      'current-report-name': currentReportName,
      'project-id': projectId,
      'two-column': false,
      reports: JSON.stringify(this.helpers.getNavReports(NavCategoryType.DataManagement)),
      order: JSON.stringify(Object.keys(this.helpers.getNavReports(NavCategoryType.DataManagement))),
      open: true,
      'workspace-id': workspaceId
    },
    on: {
      closemenu: this.helpers.handleCategoryCloseMenu
    }
  }) : null, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-data-management"
    }
  })), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Data Management") : null);
  const messagesMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-messages',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.messagesMenu
    },
    on: {
      click: () => this.helpers.selectMenuChanged("messages", !isOpen.messagesMenu)
    }
  }, isOpen.messagesMenu ? jsx(ReportsMenuEl, {
    attrs: {
      'current-report-name': currentReportName,
      'project-id': projectId,
      'two-column': false,
      reports: JSON.stringify(this.helpers.getNavReports(NavCategoryType.MessagesAndExperiments)),
      order: JSON.stringify(Object.keys(this.helpers.getNavReports(NavCategoryType.MessagesAndExperiments))),
      open: true,
      'workspace-id': workspaceId
    },
    on: {
      closemenu: this.helpers.handleCategoryCloseMenu
    }
  }) : null, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-messages"
    }
  })), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Messages") : null);
  const searchMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-search',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.searchMenu
    }
  }, jsx(GlobalSearchEl, {
    attrs: {
      open: isOpen.searchMenu
    },
    on: {
      menuChange: ev => this.helpers.selectMenuChanged("search", ev.detail.isOpen),
      searchTermSelected: this.helpers.handleSearchTermSelected
    }
  }), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Search ".concat(this.helpers.getSearchShortcutDisplayName())) : null);
  const helpMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-help',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.helpMenu
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "helpMenu",
      'menu-width': 200,
      icon: "brand-help",
      'icon-only': true,
      'align-all-text': true,
      'menu-height': 400
    },
    props: {
      sectionsFn: () => this.helpers.getHelpMenuSections()
    },
    on: {
      change: this.helpers.helpMenuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("help", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-help"
    }
  }))), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Help") : null);
  const applicationMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.applicationsMenu
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "applicationsMenu",
      'search-threshold': 10,
      'menu-width': 300,
      'menu-height': 400
    },
    props: {
      sectionsFn: () => this.helpers.getApplicationsMenuSections()
    },
    on: {
      change: this.helpers.menuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("applications", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-applications"
    }
  }))), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Applications") : null);
  const settingsMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container',
    class: {
      'mp-chrome-header-trigger-container-selected': isOpen.setupMenu
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "settingsMenu",
      'disable-search': true,
      'menu-width': 280,
      'menu-height': 480
    },
    props: {
      sectionsFn: () => this.helpers.getSettingsMenuSections()
    },
    on: {
      change: this.helpers.menuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("setup", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-settings"
    }
  }))), jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    },
    style: {
      display: this.helpers.allMenusClosed() ? "" : "none"
    }
  }, "Settings"));
  const projectMenu = jsx("div", {
    sel: '.mp-chrome-project-menu-container',
    class: {
      'mp-chrome-project-menu-container-new-nav': showNewNav
    }
  }, (() => {
    var _a, _b;

    const displayWorkspaceSelection = this.helpers.areWorkspacesActivated();
    const projectsLength = this.helpers.getProjectsForMenu().length;
    return jsx(SelectEl, {
      attrs: {
        elref: "projectsMenu",
        'search-placeholder': displayWorkspaceSelection ? "Search data views" : "Search projects",
        'menu-width': 300,
        'menu-height': 400,
        'back-button': displayWorkspaceSelection,
        'header-title': displayWorkspaceSelection ? "Data Views (".concat(projectMenuWorkspaces.length, ")") : "Projects (".concat(projectsLength, ")")
      },
      props: {
        sectionsFn: () => this.helpers.getProjectsMenuSections(),
        contextPanelTransform: this.helpers.getProjectOrWorkspaceContextPanelData
      },
      on: {
        backClick: this.helpers.selectProjectMenuBackClick,
        change: this.helpers.selectProjectMenuItem,
        menuChange: ev => this.helpers.selectMenuChanged("project", ev.detail.isOpen)
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-btn',
      attrs: {
        slot: "trigger"
      },
      class: {
        'mp-chrome-project-menu-selected': isOpen.projectMenu
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-label-container'
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-label',
      attrs: {
        title: this.helpers.getProjectAndWorkspaceName(
        /*truncated*/
        false)
      }
    }, showNewNav ? jsx(null, null, jsx("div", {
      sel: '.mp-chrome-project-menu-label-project'
    }, ((_a = this.currentProject) === null || _a === void 0 ? void 0 : _a.name) || "Loading ..."), jsx("div", {
      sel: '.mp-chrome-project-menu-label-workspace'
    }, ((_b = this.helpers.getCurrentWorkspace()) === null || _b === void 0 ? void 0 : _b.name) || "")) : this.helpers.getProjectAndWorkspaceName(
    /*truncated*/
    true)), jsx(SvgIconEl, {
      sel: '.mp-chrome-categories-label-filled-icon',
      attrs: {
        icon: "filled-caret-down"
      }
    }))), displayWorkspaceSelection ? this.helpers.getUserHasCreateWorkspacePermission() ? jsx("div", {
      sel: '.mp-chrome-project-menu-add',
      attrs: {
        slot: "footer"
      }
    }, jsx(ButtonBarEl, {
      attrs: {
        color: ButtonBarColor.Grey
      },
      on: {
        click: this.helpers.handleCreateWorkspaceBtnClick
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-button-bar-text'
    }, "Create Data View"))) : null : // do not show add project dialog for org members unless they have perms
    jsx("div", {
      sel: '.mp-chrome-project-menu-add',
      attrs: {
        slot: "footer"
      }
    }, orgData.length && (!orgData[0].id || this.helpers.getOrgsWithCreateProjectPermission().length) ? showNewProjectInput ? jsx(InputGroupEl, {
      attrs: {
        label: "Create",
        placeholder: "Name your new project..."
      },
      hook: {
        insert: vnode => requestAnimationFrame(() => vnode.elm.focus())
      },
      on: {
        input: this.helpers.updateCreateProjectName,
        submit: this.helpers.clickedCreate
      }
    }) : jsx(ButtonBarEl, {
      attrs: {
        color: ButtonBarColor.Grey
      },
      on: {
        click: this.helpers.clickedCreateProject
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-button-bar-text'
    }, "Create Project")) : null));
  })());

  const getChromeReport = (report, label) => jsx("a", {
    sel: '.mp-chrome-categories-category',
    attrs: {
      href: this.helpers.getReportUrl(report, {
        projectId,
        workspaceId
      }),
      isActiveCategory: report === currentReportName,
      elref: "chromeCategory".concat(label)
    },
    on: {
      click: () => this.helpers.handleClickReportName(report, "Top Nav")
    }
  }, jsx("div", {
    sel: '.mp-chrome-categories-label-container'
  }, jsx("div", {
    sel: '.mp-chrome-categories-label'
  }, label)));

  const getChromeCategory = function getChromeCategory(category) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const isActiveCategory = category.name === selectedCategory;
    const reportsMenuOpen = category.reports && isActiveCategory;
    return jsx(null, null, jsx("div", {
      sel: '.mp-chrome-categories-category',
      attrs: {
        elref: "chromeCategory".concat(category.name)
      },
      class: {
        'mp-chrome-categories-category-selected': isActiveCategory
      },
      on: {
        click: () => _this.helpers.toggleSelectedCategory(category.name)
      }
    }, jsx("div", {
      sel: '.mp-chrome-categories-label-container'
    }, jsx(null, null, jsx("div", {
      sel: '.mp-chrome-categories-label'
    }, name || category.label), jsx(SvgIconEl, {
      sel: '.mp-chrome-categories-label-filled-icon',
      attrs: {
        icon: "filled-caret-down"
      }
    }), reportsMenuOpen ? jsx(ReportsMenuEl, {
      attrs: {
        'current-report-name': currentReportName,
        'project-id': projectId,
        'two-column': !!category.twoColumn,
        reports: JSON.stringify(category.reports),
        order: JSON.stringify(category.order || Object.keys(category.reports)),
        open: true,
        'workspace-id': workspaceId
      },
      class: {
        'mp-chrome-categories-label-report-menu-new-nav': showNewNav
      },
      on: {
        closemenu: _this.helpers.handleCategoryCloseMenu
      }
    }) : null))));
  };

  return jsx("div", {
    sel: '.mp-chrome-header',
    class: {
      'mp-chrome-header-root': true,
      'mp-chrome-header-hidden': this.attr("hidden")
    },
    hook: !this.attr("hidden") ? this.helpers.stickyElemHooks : {}
  }, jsx("div", {
    sel: '.mp-chrome-header-row-primary',
    class: {
      'mp-chrome-header-festive-mode': !!festiveMode
    }
  }, festiveMode === FestiveMode.Luv ? jsx(FestiveModeHeaderAnimEl, null) : null, jsx("div", {
    sel: '.mp-chrome-header-inner'
  }, projectId ? jsx("div", {
    sel: '.mp-chrome-header-left'
  }, showNewNav ? jsx(null, null, jsx("a", {
    sel: '.mp-chrome-header-left-avatar',
    attrs: {
      href: this.helpers.getReportUrl(Report.Dashboards, {
        projectId,
        workspaceId
      })
    },
    on: {
      click: () => this.helpers.handleClickReportName(Report.Dashboards, "Home")
    }
  }, jsx(OrganizationIconEl, {
    attrs: {
      title: "Home"
    }
  })), jsx("div", {
    sel: '.mp-chrome-categories-container'
  }, getChromeReport(Report.Dashboards, "Dashboards"), getChromeCategory(categories ? categories["analysis"] : {
    label: "Analysis",
    name: "analysis",
    reports: {}
  }, "Reports"), getChromeReport(Report.Explore, "Users"))) : projectMenu) : null, shouldDisplayNavigationOptions ? jsx("div", {
    sel: '.mp-chrome-header-center',
    attrs: {
      elref: "chromeHeaderCenter"
    }
  }, !showNewNav ? jsx("div", {
    sel: '.mp-chrome-categories-container'
  }, getChromeReport(Report.Dashboards, "Dashboards"), Object.values(categories).map(category => getChromeCategory(category))) : jsx("div", {
    sel: '.mp-chrome-categories-container'
  }, jsx(GlobalSearchEl, {
    sel: '.mp-chrome-header-trigger-container-search',
    attrs: {
      open: isOpen.searchMenu
    },
    on: {
      menuChange: this.helpers.handleSearchMenuChange,
      searchTermSelected: this.helpers.handleSearchTermSelected
    }
  }), jsx("div", {
    sel: '.mp-chrome-categories-container-search-button',
    on: {
      click: () => this.helpers.selectMenuChanged("search", !isOpen.searchMenu)
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "search"
    },
    sel: '.mp-chrome-categories-container-search-icon'
  }), jsx("span", {
    sel: '.mp-chrome-categories-container-search-text'
  }, searchedText ? "Search: ".concat(searchedText) : "Search Dashboards & Reports ".concat(this.helpers.getSearchShortcutDisplayName()))))) : null, showNewNav ? jsx("div", {
    sel: '.mp-chrome-header-right'
  }, helpMenu, shouldDisplayNavigationOptions && this.helpers.showMessagesMenu() ? messagesMenu : null, shouldDisplayNavigationOptions && this.helpers.featuresStoreHasValue() && !this.helpers.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuApps) ? applicationMenu : null, shouldDisplayNavigationOptions ? dataManagementMenu : null, settingsMenu, projectMenu) : jsx("div", {
    sel: '.mp-chrome-header-right'
  }, shouldDisplayNavigationOptions ? searchMenu : null, helpMenu, shouldDisplayNavigationOptions && this.helpers.featuresStoreHasValue() && !this.helpers.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuApps) ? applicationMenu : null, settingsMenu))), this.helpers.shouldShowSecondaryHeader() ? jsx("div", {
    sel: '.mp-chrome-header-row-secondary'
  }, jsx("div", {
    sel: '.mp-chrome-header-row-secondary-inner'
  }, jsx("div", {
    sel: '.mp-chrome-reports-container'
  }, Object.values(((_a = categories[currentCategoryName]) === null || _a === void 0 ? void 0 : _a.reports) || {}).map(report => jsx("a", {
    sel: '.mp-chrome-reports-report',
    class: {
      'mp-chrome-reports-report-selected': report.name === currentReportName
    },
    attrs: {
      href: this.helpers.getReportUrl(report.endpoint, {
        projectId,
        workspaceId
      })
    },
    on: {
      click: () => this.helpers.handleClickReportName(report.name, "Sub Nav")
    }
  }, report.label))))) : null, errorAlertMsg ? jsx(AlertEl, {
    attrs: {
      closeable: true,
      open: true
    },
    on: {
      change: this.helpers.handleAlertChange
    }
  }, jsx("div", null, jsx("div", {
    sel: '.text'
  }, errorAlertMsg))) : null, createProjectError ? jsx(AlertEl, {
    attrs: {
      closeable: true,
      'large-icon': true,
      open: true
    }
  }, jsx("div", null, "Failed to create new project"), jsx("div", null, "Error: ", createProjectError)) : null, orgData.length && isOpen.createProjectModal ? jsx(ModalEl, {
    sel: '.mp-chrome-create-project-modal-modal',
    attrs: {
      open: true,
      closeable: true
    },
    on: {
      change: ev => this.helpers.createProjectModalChange(ev)
    }
  }, jsx("div", {
    sel: '.mp-chrome-create-project-modal-container'
  }, jsx("div", {
    sel: '.mp-chrome-create-project-modal-header'
  }, jsx("div", {
    sel: '.mp-chrome-create-project-modal-title'
  }, "Create Project")), jsx("div", {
    sel: '.mp-chrome-create-project-modal-body'
  }, jsx(InputEl, {
    attrs: {
      type: "text",
      placeholder: "e.g. Production Analytics",
      label: "Project Name"
    },
    props: {
      value: createProjectName
    },
    on: {
      input: this.helpers.updateCreateProjectName
    },
    hook: {
      insert: (_ref) => {
        let {
          elm
        } = _ref;
        return requestAnimationFrame(() => elm.focus());
      }
    }
  }), jsx("div", {
    sel: '.mp-chrome-create-project-modal-label'
  }, "Select Organization"), jsx("div", {
    sel: '.mp-chrome-create-project-modal-radio-button-container'
  }, orgData.map(org => {
    const disabled = !this.helpers.orgHasPerm(org, "create_project");
    return jsx("div", {
      sel: '.button-wrap'
    }, jsx(RadioButtonEl, {
      attrs: {
        selected: createProjectSelectedOrgId === org.id,
        disabled
      },
      on: {
        click: () => !disabled && this.helpers.selectOrg(org.id)
      }
    }, org.name), disabled ? jsx(TooltipEl, {
      attrs: {
        placement: Placement.Right
      }
    }, "You do not have permission to create projects in this organization") : null);
  }))), jsx("div", {
    sel: '.mp-chrome-create-project-modal-footer'
  }, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.helpers.clickedCancel
    }
  }, "Cancel"), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !this.helpers.projectNameValid()
    },
    on: {
      click: this.helpers.clickedCreate
    }
  }, "Create")))) : null, isOpen.inviteModal ? jsx(InviteUsersModalEl, {
    attrs: {
      open: true
    },
    props: {
      orgs: inviteModalOrgs
    },
    on: {
      save: this.helpers.closeInviteModal,
      cancel: this.helpers.closeInviteModal,
      notify: this.helpers.handleNotify,
      error: this.helpers.handleError
    }
  }) : null, isOpen.searchModal ? jsx(LoadEntityModalEl, {
    attrs: {
      open: true,
      'modal-title': "Open Report",
      'empty-message': "You don't have any saved entities yet.",
      'project-id': projectId,
      'track-name': "Content Discovery",
      'search-text': searchedText,
      'user-id': userStore.value.id,
      'workspace-id': currentWorkspace ? currentWorkspace.id : 0
    },
    on: {
      close: this.helpers.handleSearchModalClose
    }
  }) : null, showSupportWidget ? jsx(SupportWidgetEl, {
    attrs: this.helpers.supportWidgetAttrs(),
    on: {
      close: this.helpers.closeSupportWidget,
      maximize: this.helpers.handleSupportWidgetMaximize
    },
    props: {
      maximize: isSupportWidgetMaximized
    }
  }) : null, showIntroModal ? jsx(ModalEl, {
    attrs: {
      elref: "introModal",
      closeable: true,
      open: showIntroModal,
      'grow-to-content': true
    },
    on: {
      change: ev => this.helpers.onIntroModalChange(ev)
    }
  }, jsx(IntroEl, {
    attrs: {
      'first-name': (userStore.value.name || "").split(" ")[0]
    },
    on: {
      close: this.helpers.closeIntroModal
    }
  })) : null);
}